import { createContext, useEffect, useState, ReactNode } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase/firebase-config";
import {
    Loader,

} from "@mantine/core";
interface AuthContextType {
    user: any;
    loading: boolean;
}

export const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
    const [user, setUser] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    return (
        <AuthContext.Provider value={{ user, loading }}>
            {/*{loading ? <div>Loading...</div> : children}*/}
            {loading ?

                <div className="flex justify-center  w-full mt-10">
                <Loader size="lg" variant="dots" />
                </div>

                : children}



        </AuthContext.Provider>
    );
};
